export default {
    namespaced: true,
    state: {
        quickAccountBillingInfo: {
            respCode: "",
            respMsg: "",
            billingKey: "",
            financeCode: "",
            financeName: "",
            customerKey: "",
        },
    },
    mutations: {
        reset(state) {
            state.quickAccountBillingInfo = {
                respCode: "",
                respMsg: "",
                billingKey: "",
                financeCode: "",
                financeName: "",
                customerKey: "",
            };
        },
        setQuickAccountBillingInfo(state, value = {}) {
            state.quickAccountBillingInfo = value;
        }
    },
    getters: {
        selectQuickAccountBillingInfo: (state) => state.quickAccountBillingInfo,
        issuerName: (state) => state.quickAccountBillingInfo.financeName,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/quickaccountbilling.js